import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { renderBlocksList } from '../../BlockRenderer/renderBlockList.js';
import { renderChildren } from '../../BlockRenderer/renderChildren.js';
import { useClickHandler } from '../../hooks/useClickHandler.js';
import { useJSONRef } from '../../hooks/useJSONRef/useJSONRef.js';
import { CookiePopup } from '../../ui-kit/CookiePopup/CookiePopup.js';
import { DialogManager } from '../../ui-kit/DialogManager/DialogManager.js';
import { PopupManager } from '../../ui-kit/PopupManager/PopupManager.js';
import { style } from '../../utils/style.js';
const HEADER_SLOT = 'header';
const FOOTER_SLOT = 'footer';
const STICKY_FOOTER_SLOT = 'sticky-footer';
const EMPTY_DATA = {};
export const ContentPage = JSX(({ className, data = EMPTY_DATA, blocksRegistry, blockDecorator }) => {
    const { slots, blocks, fallback, ...pageContent } = data;
    const resolvedPageContent = useJSONRef(pageContent, fallback);
    useClickHandler();
    const options = {
        key: '',
        page: { slots, blocks, fallback, ...resolvedPageContent },
        blocksRegistry,
        blockDecorator,
        parent: data,
    };
    return (_jsxs("div", { "data-theme": data.colorPalette || 'pc', children: [_jsxs("section", { className: style('@container relative', data.style, className), children: [slots?.[HEADER_SLOT]?.length ? (_jsx("div", { className: "relative z-10 mb-lg shadow-[0_8px_32px_0px_#00000014]", children: renderBlocksList(slots?.[HEADER_SLOT], { ...options, slotName: HEADER_SLOT }) })) : null, _jsxs("div", { className: "container space-y-px @5xl:space-y-0 @5xl:grid @5xl:grid-cols-12 @5xl:gap-2xs", children: [renderChildren({
                                block: data,
                                options,
                                extraProps: { className: 'scroll-mt-12' },
                            }), renderBlocksList(slots?.[FOOTER_SLOT], { ...options, slotName: FOOTER_SLOT })] })] }), slots?.[STICKY_FOOTER_SLOT]?.length ? (_jsx("div", { className: "fixed w-full bottom-0 left-0 z-[100]", children: renderBlocksList(slots?.[STICKY_FOOTER_SLOT], {
                    ...options,
                    slotName: STICKY_FOOTER_SLOT,
                }) })) : null, _jsx(DialogManager, {}), _jsx(PopupManager, {}), _jsx(CookiePopup, { __html: resolvedPageContent?.cookieContent?.__html })] }));
});
Object.assign(ContentPage, {
    childrenTypes: [],
    slots: () => [HEADER_SLOT, FOOTER_SLOT, STICKY_FOOTER_SLOT],
});
//# sourceMappingURL=ContentPage.js.map